import {TOGGLE_MODAL} from './modalActionTypes';
import {IActionCreator} from '../../../interfaces/common';

export const toggleModal: IActionCreator<any> = payload => ({
    type: TOGGLE_MODAL,
    payload
});
